"use strict";

// Minimal Feedback modal: feedback | bug_report | feature_request
(function(){
  function buildModal(){
    const existing = document.getElementById('feedbackModal');
    if (existing) return existing;
    
    // Helper function to translate
    function translate(key) {
      if (window.TranslationRegistry && typeof window.TranslationRegistry.translate === 'function') {
        const lang = window.LanguageManager ? window.LanguageManager.getCurrentLanguage() : (window.LANG || 'EN');
        const translation = window.TranslationRegistry.translate(key, lang);
        if (translation !== key) return translation;
      }
      // Fallback to English defaults
      const defaults = {
        'feedback_modal_title': 'Feedback',
        'feedback_modal_close': 'Close',
        'feedback_modal_category': 'Category',
        'feedback_modal_category_feedback': 'Feedback',
        'feedback_modal_category_bug_report': 'Bug report',
        'feedback_modal_category_feature_request': 'Feature request',
        'feedback_modal_subject': 'Subject (optional)',
        'feedback_modal_message': 'Message',
        'feedback_modal_cancel': 'Cancel',
        'feedback_modal_send': 'Send'
      };
      return defaults[key] || key;
    }
    
    const html = `
<div class="modal fade" id="feedbackModal" tabindex="-1" aria-labelledby="feedbackModalLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="feedbackModalLabel" data-translate="feedback_modal_title">Feedback</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="${translate('feedback_modal_close')}"></button>
      </div>
      <div class="modal-body">
        <div class="mb-3">
          <label for="fb-category" class="form-label" data-translate="feedback_modal_category">Category</label>
          <select class="form-select" id="fb-category">
            <option value="feedback" selected data-translate="feedback_modal_category_feedback">Feedback</option>
            <option value="bug_report" data-translate="feedback_modal_category_bug_report">Bug report</option>
            <option value="feature_request" data-translate="feedback_modal_category_feature_request">Feature request</option>
          </select>
        </div>
        <div class="mb-3">
          <label for="fb-subject" class="form-label" data-translate="feedback_modal_subject">Subject (optional)</label>
          <input type="text" class="form-control" id="fb-subject" maxlength="200">
        </div>
        <div class="mb-3">
          <label for="fb-message" class="form-label" data-translate="feedback_modal_message">Message</label>
          <textarea class="form-control" id="fb-message" rows="5" maxlength="5000" required></textarea>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-outline-secondary" data-bs-dismiss="modal" data-translate="feedback_modal_cancel">Cancel</button>
        <button type="button" class="btn btn-primary" id="fb-submit" data-translate="feedback_modal_send">Send</button>
      </div>
    </div>
  </div>
</div>`;
    const div = document.createElement('div');
    div.innerHTML = html;
    document.body.appendChild(div.firstElementChild);
    const modalEl = document.getElementById('feedbackModal');
    
    // Apply translations after modal is created
    if (window.TranslationApplier && typeof window.TranslationApplier.apply === 'function') {
      setTimeout(function() {
        window.TranslationApplier.apply();
        // Also translate option elements (they need special handling)
        const options = modalEl.querySelectorAll('option[data-translate]');
        options.forEach(function(option) {
          const key = option.getAttribute('data-translate');
          if (key) {
            const translatedText = translate(key);
            if (translatedText !== key) {
              option.textContent = translatedText;
            }
          }
        });
      }, 50);
    }
    
    return modalEl;
  }

  function isAuthenticated(){
    try {
      return !!(window.SERVER_AUTH_STATUS && window.SERVER_AUTH_STATUS.isAuthenticated);
    } catch(_){ return false; }
  }

  function openModal(){
    const modalEl = buildModal();
    
    // Apply translations when modal opens (in case language changed)
    if (window.TranslationApplier && typeof window.TranslationApplier.apply === 'function') {
      setTimeout(function() {
        window.TranslationApplier.apply();
        // Translate option elements
        const options = modalEl.querySelectorAll('option[data-translate]');
        options.forEach(function(option) {
          const key = option.getAttribute('data-translate');
          if (key && window.TranslationRegistry) {
            const lang = window.LanguageManager ? window.LanguageManager.getCurrentLanguage() : (window.LANG || 'EN');
            const translatedText = window.TranslationRegistry.translate(key, lang);
            if (translatedText !== key) {
              option.textContent = translatedText;
            }
          }
        });
        // Update aria-label for close button
        const closeBtn = modalEl.querySelector('.btn-close');
        if (closeBtn && window.TranslationRegistry) {
          const lang = window.LanguageManager ? window.LanguageManager.getCurrentLanguage() : (window.LANG || 'EN');
          const closeText = window.TranslationRegistry.translate('feedback_modal_close', lang);
          if (closeText !== 'feedback_modal_close') {
            closeBtn.setAttribute('aria-label', closeText);
          }
        }
      }, 100);
    }
    
    // Close user menu if open
    const userMenuPanel = document.querySelector('[data-menu-panel]');
    if (userMenuPanel && !userMenuPanel.classList.contains('d-none')) {
      userMenuPanel.classList.add('d-none');
      const menuToggle = document.querySelector('[data-menu-toggle]');
      if (menuToggle) {
        menuToggle.setAttribute('aria-expanded', 'false');
      }
    }
    
    if (window.bootstrap && typeof window.bootstrap.Modal === 'function') {
      const modalInstance = new window.bootstrap.Modal(modalEl, {
        backdrop: true,
        keyboard: true,
        focus: true
      });
      modalInstance.show();
      // Fix backdrop z-index after modal is shown
      function fixBackdropZIndex(){
        // Find backdrop that belongs to this modal
        const backdrops = document.querySelectorAll('.modal-backdrop.show');
        backdrops.forEach(backdrop => {
          // Set z-index lower than modal
          backdrop.style.zIndex = '1065';
        });
        // Also ensure modal dialog is above backdrop
        const dialog = modalEl.querySelector('.modal-dialog');
        if (dialog) {
          dialog.style.zIndex = '1071';
          dialog.style.position = 'relative';
        }
      }
      // Fix immediately and after animation
      setTimeout(fixBackdropZIndex, 0);
      modalEl.addEventListener('shown.bs.modal', fixBackdropZIndex, { once: true });
    } else {
      modalEl.classList.add('show'); // fallback
      modalEl.style.display = 'block';
    }
  }

  async function submitForm(){
    const modalEl = document.getElementById('feedbackModal');
    if (!modalEl) return;
    const type = modalEl.querySelector('#fb-category').value || 'feedback';
    const subject = modalEl.querySelector('#fb-subject').value || '';
    const content = (modalEl.querySelector('#fb-message').value || '').trim();
    if (!content) { alert('Please enter a message'); return; }

    const payload = {
      message_type: type,
      subject: subject || null,
      content: content,
      context_url: window.location.href
    };
    try{
      const resp = await fetch('/api/messages', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });
      const data = await resp.json();
      if (resp.ok && data && data.success) {
        // Close modal
        if (window.bootstrap && typeof window.bootstrap.Modal === 'function') {
          const inst = window.bootstrap.Modal.getInstance(modalEl) || new window.bootstrap.Modal(modalEl);
          inst.hide();
        } else { modalEl.classList.remove('show'); modalEl.style.display = 'none'; }
        // Clear message field (we are sure it was sent)
        try {
          const msgField = modalEl.querySelector('#fb-message');
          if (msgField) msgField.value = '';
        } catch(_){}
        // Nice toast
        try {
          showSuccessToast('Thank you!', 'Your feedback has been sent successfully.');
        } catch(_) {
          // Fallback alert only if toast fails
          alert('Thanks for your feedback!');
        }
      } else {
        alert((data && data.error) || 'Failed to send');
      }
    } catch(e){
      console.error(e);
      alert('Network error');
    }
  }

  function ensureToastContainer(){
    // Prefer existing notifications container if present
    let container = document.getElementById('notifications-toast-container');
    if (container) return container;
    // Otherwise create a local container
    container = document.getElementById('feedback-toast-container');
    if (!container){
      container = document.createElement('div');
      container.id = 'feedback-toast-container';
      container.className = 'position-fixed top-0 end-0 p-3';
      container.style.zIndex = '1060';
      container.style.maxWidth = '400px';
      document.body.appendChild(container);
    }
    return container;
  }

  function showSuccessToast(title, text){
    const container = ensureToastContainer();
    const id = 'toast-' + Date.now();
    const useCompact = !!(window.bootstrap && window.bootstrap.Toast);
    const html = useCompact
      ? `
      <div id="${id}" class="toast mb-2 align-items-center border-0" role="status" aria-live="polite" aria-atomic="true" data-bs-delay="3800">
        <div class="toast-header bg-success text-canvas">
          <i class="bi bi-check-circle-fill me-2"></i>
          <strong class="me-auto">${escapeHtml(title || 'Success')}</strong>
          <small>now</small>
          <button type="button" class="btn-close btn-close-white ms-2 mb-1" data-bs-dismiss="toast" aria-label="Close"></button>
        </div>
        <div class="toast-body">
          ${escapeHtml(text || '')}
        </div>
      </div>`
      : `
      <div id="${id}" class="mb-2" style="background:#10b981;color:#fff;border-radius:8px;box-shadow:0 8px 24px rgba(0,0,0,.15);padding:12px 14px;display:flex;gap:10px;align-items:flex-start;">
        <div style="font-size:18px;line-height:1">✓</div>
        <div style="flex:1;">
          <div style="font-weight:700;margin-bottom:2px;">${escapeHtml(title || 'Success')}</div>
          <div style="opacity:.95;">${escapeHtml(text || '')}</div>
        </div>
        <button type="button" aria-label="Close" style="background:transparent;border:0;color:#fff;font-weight:700;cursor:pointer;">×</button>
      </div>`;
    const wrapper = document.createElement('div');
    wrapper.innerHTML = html;
    const toast = wrapper.firstElementChild;
    container.appendChild(toast);
    // Bootstrap toast
    if (window.bootstrap && typeof window.bootstrap.Toast === 'function'){
      const bsToast = new window.bootstrap.Toast(toast);
      bsToast.show();
      toast.addEventListener('hidden.bs.toast', function(){ toast.remove(); });
    } else {
      // Manual auto-hide
      const closeBtn = toast.querySelector('button');
      if (closeBtn){ closeBtn.addEventListener('click', function(){ toast.remove(); }); }
      setTimeout(function(){ if (toast && toast.parentNode) toast.remove(); }, 3800);
    }
  }

  function escapeHtml(text){
    if (text == null) return '';
    const div = document.createElement('div');
    div.textContent = String(text);
    return div.innerHTML;
  }

  function bind(){
    document.addEventListener('click', function(e){
      const a = e.target.closest('[data-feedback-toggle]');
      if (a){ e.preventDefault(); openModal(); }
    });
    document.addEventListener('click', function(e){
      if (e.target && e.target.id === 'fb-submit'){ submitForm(); }
    });
  }

  // Export to window if needed
  if (typeof window !== 'undefined') {
    window.Messages = window.Messages || {};
    window.Messages.openFeedback = openModal;
    window.Messages.showSuccessToast = showSuccessToast;
  }

  // Init
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else { bind(); }
})();


